import API, {Services} from '../../../adapters/rest';
import {Subscriptions} from '../types';
// export const getAssets = (projectId: string, query = ''): Promise<ListResponse<Asset>> => {
// };

export const getSubscriptions = (projectId: string): Promise<Subscriptions> => {
  const url = `/${Services.THINGS}/v1/projects/${projectId}/availability`;
  return API.get(url).then(response => response.data.result);
};
